/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/en-US.js'

import iconSet from 'quasar/icon-set/material-icons.js'



import {Notify,Dialog,Loading,Meta} from 'quasar'



export default { config: {"brand":{"primary":"#000000","secondary":"#262626","accent":"#00DC82","positive":"#00C667","negative":"#FF3B3B","warning":"#FF9F0A","info":"#2563FF"},"dark":true},lang,iconSet,plugins: {Notify,Dialog,Loading,Meta} }

